import { cn } from '@workspace/lib/utils/cn';

interface GradientLayerProps {
  isMobileDevice?: boolean;
  className?: string;
}

export function GradientLayer({
  isMobileDevice,
  className,
}: GradientLayerProps) {
  return (
    <div
      className={cn(
        'min-h-provi-brand-gradient absolute left-0 w-full',
        {
          'min-h-provi-brand-mob-gradient': isMobileDevice,
        },
        className,
      )}
    />
  );
}
